import React from 'react';
import TableSettingsView from '../../../../../shared/TableSettings/TableSettingsView';
import { EntityType } from '../../../../../../types/comment';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import { translate } from '../../../../../../types/translation/Translator';
import { ContainerTableSettingsColumn } from '../../../../../../types/table_settings/container/ContainerTableSettings';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';

export default function ContainerTableSettingsPane() {
  return (
    <TableSettingsView<ContainerTableSettingsColumn>
      type={EntityType.container}
      customFieldEntityType={CustomFieldEntityType.container}
      availableColumns={Object.values(ContainerTableSettingsColumn)}
      columnTextBuilder={item => translate({ key: item })}
      label={translate({ key: TranslationKey.addContainerColumn })}
      placeholder={translate({ key: TranslationKey.addContainerColumn })}
    />
  );
}
